import { Component, inject } from '@angular/core';
import { StateService } from '../../services/state.service';
import { RouterLink } from '@angular/router';
import { Button } from 'primeng/button';
import { TauresMessageModule } from '@taures/taures-components/taures-message';

@Component({
  templateUrl: './anmeldung-geloescht.component.html',
  styleUrls: ['./anmeldung-geloescht.component.scss'],
  imports: [RouterLink, Button, TauresMessageModule],
  standalone: true
})
export class AnmeldungGeloeschtComponent {
  protected readonly stateService: StateService = inject(StateService);
}
